<template>
  <v-dialog
    v-model="isDialog"
    width="500">
    <v-card>
      <v-form ref="batchCreate">
        <v-date-picker
          v-model="months"
          :allowed-dates="allowedDates"
          :locale="locale"
          multiple
          full-width
          flat
          no-title
          type="month"/>
      </v-form>
      <v-card-actions>
        <v-checkbox
          v-if="isIgnoreLastSixDays"
          v-model="ignoreLastSixDays"
          :label="$t('ignore_last_6_days')"
          hide-details
          class="ma-1"
        />
        <v-spacer/>
        <disabled-user-button>
          <v-btn
            slot-scope="{isDisabledForUser}"
            :disabled="isDisabledForUser || isLoading"
            :loading="isLoading"
            color="primary"
            @click.native="submit"
          >
            {{ $t('create') }}
          </v-btn>
        </disabled-user-button>

      </v-card-actions>
    </v-card>
    <v-btn
      slot="activator"
      color="primary"
      class="ml-2">{{ $t('submit') }}</v-btn>
  </v-dialog>
</template>

<script>
import { mapGetters } from 'vuex'
import CompanyApi from '@/api/CompanyApi'
import DisabledUserButton from '@/components/global-components/disabledUserButton/disabledUserButton'

export default {
  name: 'TimesheetBatchOneEmployeeMultipleMonths',
  components: { DisabledUserButton },
  props: [],
  data () {
    return {
      isDialog: false,
      isLoading: false,
      months: [],
      errorMessages: {},
      periodsExcludedMonths: [],
      periods: null,
      ignoreLastSixDays: false,
      lastDayOfCalculation: this.$moment().daysInMonth()
    }
  },
  computed: {
    ...mapGetters('employee', ['currentEmployee']),
    periodsFormatted () {
      if (this.periods) {
        return this.periods.map(period => {
          return {
            begin: this.$moment(period.begin),
            end: period.end ? this.$moment(period.end) : null
          }
        })
      }
    },

    isIgnoreLastSixDays () {
      let ignore = false
      const $now = this.$moment()
      const $prevIncludes = this.months.includes($now.add(-1, 'M').format('YYYY-MM'))
      const $currIncludes = this.months.includes($now.add(1, 'M').format('YYYY-MM'))
      this.months.map(month => {
        if ($now.isSame(month, 'M')) {
          if ($now.date() > 6) ignore = true
          if ($now.date() <= 6 &&
                  $prevIncludes &&
                  $currIncludes) ignore = true
        }
      })
      return ignore
    },
    locale () {
      return `${localStorage.locale}-${localStorage.locale}`
    }
  },
  methods: {
    async submit () {
      if (this.ignoreLastSixDays && this.isIgnoreLastSixDays) this.lastDayOfCalculation = this.$moment().subtract(6, 'day').format('YYYY-MM-DD')

      const months = this.months.map(month => this.$moment(month, 'YYYY-MM').format('MM-YYYY'))

      if (months.length === 1) {
        const month = months[0]
        const $now = this.$moment()
        const isThisMonth = $now.startOf('month').format('MM-YYYY') === month
        let lastDayOfCalculation = this.$moment(month, 'MM-YYYY').endOf('month')
        if (isThisMonth) {
          lastDayOfCalculation = this.$moment().subtract(1, 'days')
        }
        lastDayOfCalculation = lastDayOfCalculation.format('DD')

        this.navigateByRole({ month, lastDayOfCalculation, ignore_last_6_days: this.ignoreLastSixDays })
      } else {
        const query = {
          months: months.toString(),
          schema_id: this.currentEmployee.schema.id,
          archiveName: `${this.currentEmployee.first_name}-${this.currentEmployee.last_name}`,
          lastDayOfCalculation: this.lastDayOfCalculation,
          ignore_last_6_days: this.ignoreLastSixDays
        }

        this.$router.push({
          name: 'timesheetBatchEdit',
          query
        })
      }
    },

    closeDialog () {
      this.isDialog = false
      this.months = []
      this.errorMessages = {}
    },

    allowedDates (month) {
      const $now = this.$moment()
      const $date = this.$moment(month, 'YYYY-MM')
      const isInPast = $date.startOf('month').diff($now.startOf('month'), 'days') <= 0

      if (this.periodsExcludedMonths) {
        const isDateInInactivePeriod = this.periodsExcludedMonths.includes(this.$moment(month).format('MM.YYYY'))

        return isInPast && !isDateInInactivePeriod
      }

      return isInPast
    },
    getInactivePeriodsByRole () {
      return CompanyApi.getEmployeeInactivityPeriod(this.currentEmployee.id)
    },
    async setPeriodsForEmployeeOnDialogOpen (isOpen) {
      this.months = []
      if (isOpen) {
        this.periodsExcludedMonths = await CompanyApi.periodsExcludedMonth(this.currentEmployee.id)
        const { data } = await this.getInactivePeriodsByRole()
        this.periods = data
      }
    },
    navigateByRole (queryData) {
      // const companyId = this.currentEmployee.company_id
      const employeeId = this.currentEmployee.id
      const schemaId = this.currentEmployee.schema.id
      this.$router.push({
        name: 'timesheet',
        params: { employeeId },
        query: { schemaId, ...queryData }
      })
    }

  },
  watch: {
    isDialog: {
      immediate: true,
      handler: 'setPeriodsForEmployeeOnDialogOpen'
    },
    months: {
      deep: true,
      handler (newVal, oldVal) {
        if (this.months.length > 12) {
          this.months = oldVal
        }
      }
    }
  },
  i18n: {
    messages: {
      en: {
        create: 'Download',
        submit: 'Create time sheets',
        ignore_last_6_days: 'Ignore last 6 days'
      },
      tr: {
        create: 'İndir',
        submit: 'Zaman çizelgesi tanımla',
        ignore_last_6_days: 'Son 6 günü yoksay'
      },
      de: {
        create: 'Download',
        submit: 'Stundenzettel erstellen',
        ignore_last_6_days: 'Letzte 6 Tage ignorieren'
      },
      ru: {
        create: 'Загрузить',
        submit: 'Создать табели',
        ignore_last_6_days: 'Игнорировать последние 6 дней'
      }
    }
  }
}
</script>
